// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Copy = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.5 5.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5zm-8 8.5H14V6.5H6.5z"
    />
    <path fill="currentColor" d="M12 3v1H4v8H3V3.5a.5.5 0 0 1 .5-.5z" />
  </svg>
);
const ForwardRef = forwardRef(Copy);
export default ForwardRef;
